import constant from "../../constant";
const resource = constant.api + "storekeepers";

const state = {
  storekeepers: [],
  storekeeper: {},
};

// getters
const getters = {
  getAll: (state) => {
    return state.storekeepers;
  },

  getStorekeeper: (state) => {
    return state.storekeeper;
  },
};

// actions
const actions = {
  async setStorekeeper({ commit }, data) {
    commit("setStorekeeper", data);
  },

  async getAll({ commit }) {
    const data = await this._vm.$api.fetch(resource);
    commit("setAll", data);
  },

  async getStorekeeper({ commit }, reference) {
    const response = await this._vm.$api.show(`${resource}/${reference}`);
    const data = response.data || response;
    commit("setStorekeeper", data);
  },
};

// mutations
const mutations = {
  setAll(state, data) {
    state.storekeepers = Array.isArray(data) ? data : data?.data || [];
  },

  setStorekeeper(state, data) {
    state.storekeeper = data?.data || data || {};
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
